<template>
  <div class="p-success--container">
    <section class="p-success--container__information">
      <BoxNotification
        :notificationState="'success'"
        :hideCloseButton="this.hideCloseButton"
        v-if="this.items"
      >
        <p slot="message" class="m-boxNotification__Message">
          <template v-if="isPendingSubscription">
            <span class="m-boxNotification__Message--Bold">Success</span> - Thanks for your order - We've added a pending <span class="m-boxNotification__Message__Product">{{ productNames }}</span> to your account. A confirmation email will be sent to <span class="m-boxNotification__Message--Bold">{{ emailAddress }}</span> once your prepaid credit is used up and your subscription begins.
          </template>
          <template v-else>
            <span class="m-boxNotification__Message--Bold">Success</span> - Thanks for your purchase. We've added <span class="m-boxNotification__Message__Product">{{ productNames }}</span> to your account. A confirmation email has been sent to <span class="m-boxNotification__Message--Bold">{{ emailAddress }}</span>
          </template>
        </p>
      </BoxNotification>
      <BoxNotification
        v-if="doesUserAlreadyOwnThisLicense"
        :hideCloseButton="this.hideCloseButton"
        :notification-state="'warning'"
      >
        <p slot="message" class="m-boxNotification__Message">
          <span class="m-boxNotification__Message--Bold">Heads up</span> - {{ doesUserAlreadyOwnThisLicenseMessage }}.
          <span class="m-boxNotification__Message--Link">
            <a href="https://account.serato.com/#/subscriptions">
              <button class="a-Button--Small a-Button--notifications a-Button--notifications--warning">Manage</button>
            </a>
          </span>
        </p>
      </BoxNotification>
      <BoxInfos
        v-if="this.productGetSteps"
        :steps="this.stepProduct.steps"
      >
      </BoxInfos>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Axios from 'axios'
import BoxNotification from '../molecules/BoxNotification.vue'
import BoxInfos from '../molecules/BoxInfo.vue'
import ProductJson from '../../resources/products.json'

export default {
  components: {
    BoxNotification,
    BoxInfos
  },
  computed:
    mapState({
      emailAddress: state => state.user.emailAddress,
      redirectUrl: state => state.globalstate.redirectUrl
    }),
  data () {
    return {
      items: [],
      ownedSubscriptionsProductTypeIds: [],
      isSubscription: false,
      isPendingSubscription: false,
      billingPeriod: 1,
      expansionPackIds: [72, 73, 79, 80, 81, 82, 85, 86, 62, 64, 65, 66, 67, 106, 107, 130, 131],
      doesUserAlreadyOwnThisLicense: '',
      doesUserAlreadyOwnThisLicenseMessage: '',
      stepProduct: [],
      productGetSteps: false,
      productNames: '',
      hideCloseButton: true
    }
  },

  created () {
    this.showOrderTotal()
    Axios.get('/success/info')
    .then((response) => {
      if (response.data.length === 0) {
        this.$router.push({ path: '/cart' })
        return
      }
      this.$store.dispatch('cart/removeCart')
      this.updateHeader()
      this.ownedSubscriptionsProductTypeIds = response.data.items.ownedSubscriptionsProductTypeIds
      delete response.data.items.ownedSubscriptionsProductTypeIds
      this.items = response.data.items
      this.isSubscription = response.data.items[0].product_type.is_subscription
      this.isPendingSubscription = response.data.items[0].product_type.is_pending_subscription
      this.billingPeriod = response.data.items[0].product_type.billing_period
      this.getProductSteps(response.data.items[0].product_type.id)
    })
    .catch((error) => {
      if (error.response.data.code === 3001) {
        this.$router.push({ path: '/payment' })
      }
      console.error(error)
    }).finally(() => {
      this.doesUserOwnSubscriptionWithPurchasedProduct()
    })
  },
  mounted () {
    if (this.redirectUrl) {
      window.setTimeout(this.redirectOnSuccess, 5000)
    }
  },
  updated () {
    this.purchasedProducts()
  },
  methods: {
    showOrderTotal () {
      this.$store.dispatch('globalstate/updateShowOrderTotal', false)
    },
    updateHeader () {
      this.$store.dispatch('globalstate/updateHeaderCaption', 'Success')
    },
    redirectOnSuccess () {
      // Let's redirect the user.
      window.location = this.redirectUrl
    },
    doesUserOwnSubscriptionWithPurchasedProduct () {
      /* All spec for this function can be found here:
        http://confluence.akld.serato.net:8090/display/PROJ/Improvements+to+Express+Checkout+success+page+-+Spec
      */

      let alreadyOwnedLicenseMessage = 'You have a subscription that includes a license you have just purchased. '
      alreadyOwnedLicenseMessage += 'If you no longer need this subscription, you can cancel it in My Account'
      if (this.hasSubscriptionWithDjPro() && this.hasPurchasedProductWithDjPro()) {
        this.doesUserAlreadyOwnThisLicense = true
        this.doesUserAlreadyOwnThisLicenseMessage = alreadyOwnedLicenseMessage
        return
      } else if (this.hasDjSuiteSubscription() && this.hasPurchasedProductWithExpansions()) {
        // Bit of an edge case, Suite is the only product with expansions where we don't want a message.
        return
      } else if (this.hasDjToolkitSubscription() && this.hasNotPurchasedToolkitExpansions()) {
        // User who has toolkit sub should not see message when purchasing dvs or video.
        return
      } else if (this.hasSubscriptionWithExpansions() && this.hasPurchasedProductWithExpansions()) {
        this.doesUserAlreadyOwnThisLicense = true
        this.doesUserAlreadyOwnThisLicenseMessage = alreadyOwnedLicenseMessage
        return
      } else if (this.hasPurchasedToolkit() && this.hasDjToolkitSubscription()) {
        this.doesUserAlreadyOwnThisLicense = true
        this.doesUserAlreadyOwnThisLicenseMessage = alreadyOwnedLicenseMessage
        return
      } else if ((this.hasPurchasedSeratoStudio() && this.hasStudioSubscription())) {
        this.doesUserAlreadyOwnThisLicense = true
        this.doesUserAlreadyOwnThisLicenseMessage = alreadyOwnedLicenseMessage
        return
      } else if (
          (this.hasPurchasedSeratoStudio() || this.hasPurchasedProductWithDjPro()) &&
          this.hasProducerDjSubscription()
      ) {
        this.doesUserAlreadyOwnThisLicense = true
        this.doesUserAlreadyOwnThisLicenseMessage = alreadyOwnedLicenseMessage
        return
      } else {
        this.doesUserAlreadyOwnThisLicense = false
      }
    },
    hasPurchasedProductWithDjPro () {
      return this.hasPurchasedDjSuite() || this.hasPurchasedDjPro() || this.hasPurchasedDjEssentials() || this.hasPurchasedClubKit()
    },
    hasPurchasedProductWithExpansions () {
      return this.hasPurchasedDjSuite() || this.hasPurchasedExpansionsBundle() || this.hasPurchasedAnExpansionPack()
    },
    hasPurchasedDjPro () {
      // Loop thru items and find a DJ Pro
      for (const item in this.items) {
        if ([57, 58].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedDjEssentials () {
      // Loop thru items and find a DJ Essentials
      for (const item in this.items) {
        if ([147].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedDjSuite () {
      // Loop thru items and find a DJ Suite
      for (const item in this.items) {
        if ([95, 96].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedClubKit () {
      for (const item in this.items) {
        if ([91, 92].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedToolkit () {
      for (const item in this.items) {
        if ([93, 94].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedAnExpansionPack () {
      for (const item in this.items) {
        if (this.expansionPackIds.includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedExpansionsBundle () {
      for (const item in this.items) {
        if ([142].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasPurchasedSeratoStudio () {
      // Loop thru items and find a Serato Studio
      for (const item in this.items) {
        if ([145].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasNotPurchasedToolkitExpansions () {
      for (const item in this.items) {
        if ([107, 82].includes(this.items[item].product_type.id)) {
          return true
        }
      }
      return false
    },
    hasSubscriptionWithDjPro () {
      return this.hasDjSuiteSubscription() ||
      this.hasDjProSubscription() ||
      this.hasDjEssentialsSubscription() ||
      this.hasDjClubKitsubscription()
    },
    hasSubscriptionWithExpansions () {
      return this.hasDjSuiteSubscription() ||
      this.hasDjExpansionsSubscription() ||
      this.hasDjToolkitSubscription()
    },
    hasDjProSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(103) || this.ownedSubscriptionsProductTypeIds.includes(133) || this.ownedSubscriptionsProductTypeIds.includes(153)
    },
    hasDjClubKitsubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(149)
    },
    hasDjSuiteSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(105)
    },
    hasDjEssentialsSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(132)
    },
    hasDjExpansionsSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(104)
    },
    hasDjToolkitSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(148)
    },
    hasStudioSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(136) || this.ownedSubscriptionsProductTypeIds.includes(138)
    },
    hasProducerDjSubscription () {
      return this.ownedSubscriptionsProductTypeIds.includes(154)
    },
    getProductSteps (productTypeId) {
      this.stepProduct = ProductJson.find(product => {
        return product.productId.includes(productTypeId)
      })
      if (this.stepProduct.steps.length > 0) {
        this.productGetSteps = true
      }
    },
    purchasedProducts () {
      const productNamesList = []
      if (this.items) {
        for (const index in this.items) {
          productNamesList.push(this.items[index].product_type.name)
        }
        this.productNames = productNamesList.join(', ')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Success.vue?5623b6e0